<!-- header part start-->
<div class="container-fluid webView" style="padding: 0px 5px;">
      <div class="col-md-12 col-12 col-sm-12" style="display: flex; align-items: center; padding: 15px 0px;">
          <div class="col-md-3 col-sm-3">
              <h2 class="header lblHeader newHeader" style="font-size: 25px;">
                {{reportTitle}}
              </h2>
          </div>
          <div class="col-md-9 col-sm-9" style="text-align: right;">
            <span class="">
              <span class="fa fa-search" style="padding-left: 13px; font-size: 14px;
              position: absolute;top: 8px;color: #999;"></span>
                <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                (keyup)="searchFilter($event)" style="text-align: left; background-color: white; display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 45% !important; height: 31px !important;"
                type="text">   
            </span>

            <span *ngIf="userRights.POEntry" class="btn btn-orange brdrRadius3" style="padding: 3px 10px ; font-size: 13px; margin-left: 10px; line-height: 1.66em;" (click)="openPO()">
                  <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                  <span> Create PO </span>
            </span>
            <span class="btn btn-orange brdrRadius3"
                style="padding: 3px 10px ; font-size: 13px; margin-left: 10px; line-height: 1.66em;" *ngIf="rptType == 3">
                  <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                  <span> Launch Job </span>
            </span>


            <span (click)="exportToExcelActivities()" class="darkBlueButton"
              style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
              <span>
                <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
              </span>
            </span>

            <span (click)="refresh()" class="darkBlueButton" style="margin-left: 10px; cursor: pointer;" title="Refresh">
                <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
            </span>
    
              <div style="display: inline-block; padding: 0px;" title="Return to Inventory">
                  <span class="darkBlueButton"
                      style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
                      (click)="backBtn()">
                      <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                  </span>
              </div>
  
          </div>
      </div>
  <!-- filter -->
  <div class="col-md-12 col-12 col-sm-12">
    <div style="display: flex; width: 100%; align-items: center; gap: 10px; " >
      <!-- Item Type -->
      <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.type" (change)="applyFilter('type')">
        <option [ngValue]="0">All Items</option>
        <option [ngValue]="1">Products</option>
        <option [ngValue]="2">Materials</option>
        <option [ngValue]="3">Spares</option>
        <option [ngValue]="4">Assemblies</option>
      </select>

      <!-- Categories -->
      <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.categoryID" (change)="applyFilter('category')">
        <option [ngValue]="0">All Categories</option>
        <option *ngFor="let c of categories" [ngValue]="c.cid">{{c.cnm}}</option>
      </select>

        <!-- Sub-Categories -->
        <select disabled="{{subCategories.length == 0}}" class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.subCategoryID" (change)="applyFilter('subcategory')">
          <option [ngValue]="0">All Sub-Categories</option>
          <option *ngFor="let sc of subCategories" [ngValue]="sc.sid">{{sc.snm}}</option>
        </select>

        <!-- Importace -->
        <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.importanceID" (change)="applyFilter('imp')">
          <option [ngValue]="3">All Importance Levels</option>
          <option [ngValue]="0">Low</option>
          <option [ngValue]="2">Normal</option>
          <option [ngValue]="1">High</option>
        </select>

        <!-- Sources -->
        <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.source" (change)="applyFilter('source')">
          <option [ngValue]="0">All Sources</option>
          <option [ngValue]="1">Internal Manufacturing</option>
          <option [ngValue]="2">Purchase</option>
        </select>

        <!-- Stock Level -->
        <label for="stkLvl" style="font-family: inherit; font-size: 13px; margin: 0px; display: flex; gap: 5px;">
          <input  type="checkbox" name="" id="stkLvl" [(ngModel)]="selectedFilter.stockLevelSel" (change)="applyFilter('minStock')">
          Stock Level
        </label>

        <div class="fntSz">
          <input class="form-control formCtlFltr widthAuto" style="width: 60px;" type="number" min="0" max="100" [(ngModel)]="selectedFilter.stockLevel">
          <span> % or less of min Qty</span>
        </div>
        
    </div>
  </div>
  
  <!-- Table -->
      <div class="wrapper" style="overflow: auto; padding-left: 0px !important; text-overflow: ellipsis; white-space: nowrap; padding-top: 5px; padding-right: 14px;border-radius: 3px;" *ngIf="dataSource.data.length > 0" #csttable>
        <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;">
          <ng-container matColumnDef="ItemName">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
              <label style="font-size: 13px;">Item</label>
            </th>
            <td mat-cell *matCellDef="let element" style="padding-right: 52px !important;"> {{element.ItemName}} </td>
          </ng-container>

          <ng-container matColumnDef="minStock">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Min Qty</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{element.minStock }} </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="pndgSOQty">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Orders</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{element.pndgSOQty}} </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="currentStock">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 5px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Stock</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{element.currentStock }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="pndgPOQty">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">PO</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{element.pndgPOQty }} </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="pndgPrdJobQty">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">WIP</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{element.pndgPrdJobQty}} </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="planQty">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Plan</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{element.planQty}} </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="shortfall">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 13px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Shortfall</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{
                    element.hasDiffUnits ? '?' : (element.shortfall <= 0 ? '-' : element.shortfall)
                  }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="SKU">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 2px;">
              <label style="font-size: 13px; padding-right: 4px;">Unit</label>
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: left;vertical-align: middle;" > 
              {{element.hasDiffUnits ? '?' : element.SKU}}  
            </td>
          </ng-container>

          <ng-container matColumnDef="currentLevel">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Level</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="text-align: right; padding-right: 11px;">
                  {{
                    element.hasDiffUnits ? '?' : (element.minStock == 0 ? '-' : element.currentLevel + ' %')
                  }}
                </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="leadTime">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 8px; padding-top: 10px; padding-bottom: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Lead Time</label>
            </th>
            <td mat-cell *matCellDef="let element">
                <div style="padding-right: 11px;">
                  {{element.leadTime != 1 ? element.leadTime + ' days' : element.leadTime + ' day'}} </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="Actions">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" style="text-align: right;">
              <div *ngIf="showItemSummary" class="lableBtnOrange inLneBlk" style="cursor: pointer;" (click)="openItemSummary(element);" title="Item Summary">
                <i class="fa fa-sticky-note-o" aria-hidden="true" style="margin-left: 1px; margin-right: 1px; vertical-align: middle;"></i>
              </div>
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="enoughStkFor">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;padding-left: 2px;">
              <label style="font-size: 13px; padding-right: 4px;">Enough Stock For (Days)</label>
              <div class="filter" floatLabel="never" style="display: none;">
                <input matInput class="form-control seachInput" [formControl]="enoughStockFilter" style="border: none; border-bottom: 1px solid; width: 120px; font-size: 14px;">
              </div>
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: left;vertical-align: middle;" > to be calc </td>
          </ng-container> -->
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
       <!-- Angular 8 pagination -->
       <mat-paginator
            [pageSizeOptions]="[10, 15]" showFirstLastButtons>
       </mat-paginator>
    </div>
    <div *ngIf="dataSource.data.length == 0">
      <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
    </div>
</div>

<div class="container-fluid padMob bg  mobView bggray" style="padding-right: 0px; margin-bottom: 15px;">
  <div class="row">
    <!-- Header -->
    <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding-bottom: 0px;">
      <div class="col-md-6 col-6 col-sm-6 pad0 inLneBlk">
        <h4 style="font-size: 30px;" class="newHeader">{{reportTitle}}</h4>
      </div>
      <div class="col-md-6 col-6 col-sm-6 pad0 inLneBlk" style="vertical-align: top;">
        <span class="btn darkBlueButton" style="float: right; position: relative; padding: 2px 9px;" (click)="backBtn()">
          <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
        </span>
        <span (click)="refresh()" class="darkBlueButton" style="margin-right: 8px; float: right; cursor: pointer;" title="Refresh">
          <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
        </span>
        <span class="darkBlueButton mobileView" style="margin-right: 8px !important; float: right; font-size: 14px; cursor: pointer; position: relative;" (click)="exportToExcelActivities()">
          <i class="fa fa-file-excel-o"></i>
        </span>
      </div>
    </div>

    <!-- Search -->
    <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 10px 15px 0px 15px;">
      <div class="input-icons search">
        <span class="fa fa-search" style="top: 17px !important;"></span>
        <input class="form-control formCtlFltr brdrRadius3" [(ngModel)]="search" placeholder="Search"
          style="padding-left: 35px !important; box-shadow: none; border: 1px solid #e4e4e4 !important; width: 100%; float: left; max-width: 360px;"
          type="text">
      </div>
    </div>
    
    <!-- Filters -->
    <div style="width: 100%; margin-top: 10px; padding-left: 15px; padding-right: 15px;">
      <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
        <!-- Category Filter -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selectedFilter.categoryID" tabindex="1" (change)="applyFilter('category')">
          <option [value]="0">All Categories</option>
          <option *ngFor="let c of categories" [value]="c.cid">{{c.cnm}}</option>
        </select>
        <!-- Sub-Category Filter -->
        <select [disabled]="subCategories.length == 0" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selectedFilter.subCategoryID" tabindex="1" (change)="applyFilter('subcategory')">
          <option [value]="0">All Sub-Categories</option>
          <option *ngFor="let sc of subCategories" [value]="sc.sid">{{sc.snm}}</option>
        </select>
      </div>

      <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
        <!-- Importance Filter -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selectedFilter.importanceID" (change)="applyFilter('imp')">
          <option value="3">All Importance Levels</option>
          <option value="0">Low</option>
          <option value="2">Normal</option>
          <option value="1">High</option>
        </select>

        <!-- Sources -->
        <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 50%; max-width: 180px;" [(ngModel)]="selectedFilter.source" (change)="applyFilter('source')">
          <option [ngValue]="0">All Sources</option>
          <option [ngValue]="1">Internal Manufacturing</option>
          <option [ngValue]="2">Purchase</option>
        </select>
      </div>

      <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px; max-width: 360px;">
        <!-- Item Type -->
        <select class="form-control formCtlFltr bgwhite widthAuto" [(ngModel)]="selectedFilter.type" (change)="applyFilter('type')">
         <option [ngValue]="0">All Items</option>
         <option [ngValue]="1">Products</option>
         <option [ngValue]="2">Materials</option>
         <option [ngValue]="3">Spares</option>
         <option [ngValue]="4">Assemblies</option>
        </select>
     </div>
    </div>

    <div style="width: 100%; padding-left: 15px; padding-right: 15px; display: flex; align-items: center;  margin-bottom: 10px;">
      <label for="stkLvl" style="font-family: inherit; font-size: 13px; margin: 0px; display: flex; gap: 5px; margin-right: 8px;">
        <input  type="checkbox" name="" id="stkLvl" [(ngModel)]="selectedFilter.stockLevelSel" (change)="applyFilter('minStock')">
        Stock Level
      </label>

      <div class="fntSz">
        <input class="form-control formCtlFltr widthAuto" style="width: 60px;" type="number" min="0" max="100" [(ngModel)]="selectedFilter.stockLevel">
        <span> % or less of min Qty</span>
      </div>
    </div>

    <div style="width: 100%; padding-left: 15px; padding-right: 15px; display: flex; align-items: center;">
      <span *ngIf="userRights.POEntry" class="btn btn-orange brdrRadius3" style="padding: 3px 10px ; font-size: 13px; line-height: 1.66em;" (click)="openPO()">
        <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
        <span> Create PO </span>
      </span>
    </div>
  </div>
  <div class="row" style="margin-top: 10px;">
    <div class="col-md-12 col-sm-12 col-xs-12" id="mobList" >
      <div *ngIf="dataSource.data.length == 0" style="margin: 10px 15px; color: #555;">
        <span class="font12">No Stock Items Found.</span>
      </div>
      <!-- list box -->
      <div *ngFor="let item of dataSource.data | filter:'ItemName':search" style="margin-top: 10px; border: 1px solid #ddd; border-radius: 3px; padding: 10px; width: 100%;">
          <div style="display: flex; align-items: center; justify-content: space-between;">
              <div style="font-size: 16px;">
                  {{item.ItemName}}
              </div>
              <div style="display: flex; align-items: center; column-gap: 8px;">
                <div *ngIf="showItemSummary" class="lableBtnOrange inLneBlk" style="cursor: pointer; font-size: 13px !important;" (click)="openItemSummary(item);" title="Item Summary">
                  <i class="fa fa-sticky-note-o" aria-hidden="true" style="margin-left: 1px; margin-right: 1px; vertical-align: middle;"></i>
                </div>
              </div>
          </div>
          <div style="display: flex; align-items: center; column-gap: 4px; flex-wrap: wrap;">
            <!-- Stock and Stock Levels -->
            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" *ngIf="item.minStock" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              Min Qty : <b> {{item.minStock + ' ' + item.SKU}} </b>
            </div>
            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" *ngIf="item.currentStock" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              Stock : <b> {{item.currentStock + ' ' + item.SKU}} </b>
            </div>

            <!-- Qty -->
            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              PO : <b> {{item.pndgPOQty + ' ' + item.SKU}} </b>
            </div>
            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              Orders : <b> {{item.pndgSOQty + ' ' + item.SKU}} </b>
            </div>
            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              WIP : <b> {{item.pndgPrdJobQty + ' ' + item.SKU}} </b>
            </div>
            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              Plan : <b> {{item.planQty + ' ' + item.SKU}} </b>
            </div>
            <div *ngIf="item.shortfall > 0" class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              Shortfall : <b> {{item.hasDiffUnits ? '?' : item.shortfall + ' ' + item.SKU}} </b>
            </div>

            <div class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              Lead Time : <b> {{item.leadTime != 1 ? item.leadTime + ' days' : item.leadTime + ' day'}} </b>
            </div>

            <div *ngIf="item.minStock > 0" class="darkBlueBadge darkBlueBrdr brdrRadius3" style="margin: 5px 5px 0px 0px; font-size: 13px; padding: 3px 10px;">
              <b>Level : {{item.hasDiffUnits ? '?' : item.currentLevel + ' %'}}</b>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
  